<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-sm-6 offset-sm-3 border border-secondary brs p-3 text-center">
          <div class="h-100 pt-3">
            <div class="d-flex justify-content-center align-items-center">
              <img
                src="@/assets/img/tick_selector.png"
                class="img-fluid d-inline-block"
                alt="Transfer complete"
              />
              <h4 class="d-inline-block my-auto pl-2">Transfer Complete</h4>
            </div>
            <div class="mt-4 font-weight-bold">
              <router-link 
                :to="{path: '/dashboard/' + $store.state.customers.customer.CustomerReference}" 
                target="_blank"
                class="underline">
                1 - View old customer
              </router-link>
            </div>
            <div class="mt-4 font-weight-bold pb-3">
              <router-link 
                v-if="transferResponse"
                :to="{path: '/dashboard/' + transferResponse.CustomerReference}" 
                target="_blank"
                class="underline">
                2 - View new customer
              </router-link>
              <span v-else class="underline text-muted">
                2 - View new customer
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    transferResponse() {
      return this.$store.state.transfer.transferResponse;
    }
  },
};
</script>